<button
  mat-flat-button
  color="primary"
  type="button"
  class="start-tour-button"
  *ngIf="
    (onboardingService.currentAvailableTour | async) &&
    !onboardingService.isActive
  "
  (click)="onboardingService.startCurrentAvailableTour()"
>
  {{ "onboarding.activateTourButton" | translate }}
</button>
